import React from 'react'
import { components } from 'react-select'

import { useStyles } from '../styles'

const SelectValueContainer = props => {
  const { isIconSelect, showIndicator, showClearInputIcon, Icon } = props.selectProps

  const classes = useStyles({ isIconSelect, showIndicator, showClearInputIcon })

  return (
    <div className={classes.valueContainer}>
      {Icon && Icon}
      <components.ValueContainer {...props} />
    </div>
  )
}

export default SelectValueContainer
